/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import { useIntl } from "react-intl";

import "./ExpandableSearch.scss";
import { ReactComponent as SearchIcon } from "assets/images/icons/Search.svg";

type ExpandableSearchProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  alwaysExpanded?: boolean;
  containerClasses?: string;
  placeholder?: string;
};

function ExpandableSearch(props: ExpandableSearchProps) {
  const intl = useIntl();
  const { value, onChange, alwaysExpanded, containerClasses, placeholder } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearchIconClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className={`search-container-expandable ${containerClasses}`} data-testid="expandable-search-container">
      <SearchIcon className="search-icon" onClick={handleSearchIconClick} data-testid="expandable-search-icon" />
      <input
        className={`font-b3 search-input ${alwaysExpanded || value ? "expended" : ""}`}
        ref={inputRef}
        placeholder={
          placeholder ??
          intl.formatMessage({
            id: "general.search",
            defaultMessage: "Search",
          })
        }
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default ExpandableSearch;

ExpandableSearch.defaultProps = {
  alwaysExpanded: false,
  containerClasses: "",
  placeholder: undefined,
};
